import { CHARGE_USER_FAILURE, CHARGE_USER_REQUEST, CHARGE_USER_SUCCESS, CLEAR_CHARGED_USER_DATA } from '../constants/chargeUser.constants';

const initialState = {
    loading: false,
    data: [],
    errorMsg: '',
};

export const chargeUserReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case CHARGE_USER_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
                errorMsg: '',
            };
        case CHARGE_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
            };
        case CHARGE_USER_FAILURE:
            return {
                ...state,
                loading: false,
                errorMsg: action.payload,
            };
        case CLEAR_CHARGED_USER_DATA:
            return {
                ...state,
                loading: false,
                data: [],
                errorMsg: '',
            };
        default:
            return state;
    }
};
